import { Component } from 'react';
import {connect} from 'react-redux';
import {Col, Row} from 'react-bootstrap';
import DOMPurify from 'dompurify';
import {loadPageContent} from '../../../../actions/content';

class TextViewer extends Component {
  componentDidMount() {
    this.props.dispatch(loadPageContent(`api/pages/${this.props.pageSlug}`));
  }

  render() {
    const contentText = this.props.contents[`${this.props.pageSlug}_content_text`];

    if (contentText) {
      return (
        <Row>
          <Col lg={12} className="editable-content-wrapper">
            <div dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(contentText.body)}}/>
          </Col>
        </Row>
      );
    }
    return null;
  }
}

const mapStateToProps = state => ({
  contents: state.content.list,
});

export default connect(mapStateToProps)(TextViewer);
